import classNames from 'classnames';
import { string, func, bool, node, oneOf } from 'prop-types';
import React from 'react';

import classes from './Button.module.scss';

function Button({
  className,
  onBlur,
  type,
  onClick,
  name,
  disabled = false,
  children,
  active,
  secondary,
  removeHoverEffect,
  bottomFixed,
  ...rest
}) {
  return (
    <button
      className={classNames(
        'globalButton font-weight-500 font-18 font-sm-14',
        classes.input,
        { [classes.secondaryClass]: secondary },
        { [classes.removeHoverEffect]: removeHoverEffect && !active },
        { [classes.activeButton]: active },
        { [classes.bottomFixed]: bottomFixed },
        className
      )}
      disabled={disabled}
      name={name}
      onBlur={onBlur}
      onClick={onClick}
      // eslint-disable-next-line react/button-has-type
      type={type}
      {...rest}
    >
      {children}
    </button>
  );
}

Button.propTypes = {
  active: bool,
  bottomFixed: bool,
  children: node,
  className: string,
  disabled: bool,
  name: string,
  onBlur: func,
  onClick: func,
  removeHoverEffect: bool,
  secondary: bool,
  type: oneOf(['button', 'submit', 'reset'])
};

Button.defaultProps = {
  active: true,
  bottomFixed: true,
  children: 'Submit',
  className: '',
  disabled: false,
  name: 'button',
  onBlur: () => {},
  onClick: () => {},
  removeHoverEffect: false,
  secondary: false,
  type: 'button'
};

export default Button;
